(function () {
  'use strict';

  var GUIDANCE = {
    sweet: {
      label: 'Too sweet',
      title: 'Restore definition before adding more alcohol.',
      cause: 'The sweet component may be oversized, the acidity may be undersized, or the drink may simply be too warm to feel crisp.',
      action: 'Confirm temperature and dilution. Then add acidity in a small measured increment, or lengthen an appropriate highball with unsweetened soda.',
      retest: 'Integrate the change completely and taste again. Stop when the drink regains definition, not when sweetness disappears.',
      pro: 'Audit the cordial, syrup, liqueur, juice, and rim measures. Test the correction in one small sample before scaling it to a batch.'
    },
    tart: {
      label: 'Too tart',
      title: 'Round the edge with a measured counterweight.',
      cause: 'The acidic component may be oversized, the sweet component may be undersized, or the recipe may have been judged before proper dilution.',
      action: 'Confirm each measure. Add sweetness or a compatible rounded modifier in a small measured increment; do not add spirit merely to hide acidity.',
      retest: 'Integrate, chill if needed, and taste again. The goal is structure with a clean finish, not the removal of all tartness.',
      pro: 'Check the jigger, bottle positions, citrus or acid prep, and batch math. Record the successful correction in the service spec.'
    },
    hot: {
      label: 'Too hot or strong',
      title: 'Check chilling and dilution before rewriting the spec.',
      cause: 'The drink may be warm, under-diluted, or built with a stronger base than the tested reference.',
      action: 'For a just-made drink, add a little more controlled chilling and dilution through the intended method. For a batch, compare the service method with the tested single drink.',
      retest: 'Taste at the intended serving temperature. If it still feels unintegrated, revisit the measured base-to-mixer ratio.',
      pro: 'Record spirit proof, starting temperature, ice, contact time, and planned pre-dilution. Train to the observable finished result.'
    },
    thin: {
      label: 'Thin',
      title: 'Separate missing body from excess water.',
      cause: 'The drink may be over-diluted, missing a measured body-building component, or built at a larger finished volume than intended.',
      action: 'Check the recipe measures and finished volume. If dilution is correct, restore the intended cordial, sweetener, foam, dairy, fruit, or other texture component rather than adding sweetness blindly.',
      retest: 'Compare weight and finish after the measured correction. A drink can be crisp without feeling empty.',
      pro: 'Weigh or measure the finished reference drink, then audit batch yield and add-at-service components for volume drift.'
    },
    flat: {
      label: 'Flat or dull',
      title: 'Restore contrast and the first aromatic impression.',
      cause: 'The drink may be too warm, stale, low in acidity, missing carbonation, or served without the aroma the recipe expects.',
      action: 'Check freshness, temperature, and any intended carbonation. Add a recipe-appropriate fresh aroma or test acidity in a small measured increment.',
      retest: 'Smell before sipping. If the opening is lively but the middle is still dull, revisit acidity and dilution one at a time.',
      pro: 'Inspect garnish prep, open-bottle quality, carbonation timing, glass temperature, and hold time before changing the master recipe.'
    },
    watery: {
      label: 'Watery',
      title: 'Stop dilution and rebuild a controlled test.',
      cause: 'Too much pre-dilution, warm ingredients, long ice contact, weak carbonation, or a mismatch between batch and service method can wash out the drink.',
      action: 'Water cannot be removed from the finished drink. Rebuild a smaller test with colder ingredients, controlled pre-dilution, or shorter contact with ice.',
      retest: 'Serve the test in the intended glass and at the intended temperature. Compare it directly with the original.',
      pro: 'Audit total finished volume, hold temperature, ice condition, pour size, and add-at-service steps. Correct the process before changing ingredient ratios.'
    }
  };

  function initialize(root) {
    if (!root || root.getAttribute('data-ccbd-ready') === 'true') return;

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-ccbd-symptom]'));
    var fields = {
      label: root.querySelector('[data-ccbd-result-label]'),
      title: root.querySelector('[data-ccbd-result-title]'),
      cause: root.querySelector('[data-ccbd-result-cause]'),
      action: root.querySelector('[data-ccbd-result-action]'),
      retest: root.querySelector('[data-ccbd-result-retest]'),
      pro: root.querySelector('[data-ccbd-result-pro]')
    };

    if (!buttons.length || Object.keys(fields).some(function (key) { return !fields[key]; })) return;

    function select(button) {
      var record = GUIDANCE[button.getAttribute('data-ccbd-symptom')];
      if (!record) return;

      buttons.forEach(function (candidate) {
        candidate.setAttribute('aria-pressed', candidate === button ? 'true' : 'false');
      });
      Object.keys(fields).forEach(function (key) {
        fields[key].textContent = record[key];
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () { select(button); });
    });

    root.setAttribute('data-ccbd-ready', 'true');
  }

  function initializeAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-cc-balance-diagnostic]'), initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
}());
